import { Component, input, Input, Output, EventEmitter } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import {
    DREVerticalReferences,
    VisualizationOptionsType
} from "@arch/_shared/types/options-visualization";

@Component({
    selector: "app-form-dre-balance-options",
    imports: [SharedMaterialModule, FormsModule],
    templateUrl: "./form-dre-balance-options.component.html",
    styleUrl: "./form-dre-balance-options.component.scss"
})
export class FormDreBalanceOptionsComponent {
    @Input({ required: true }) form: FormDreBalanceOptions = {
        analysisHorizontal: false,
        analysisVertical: false,
        verticalReference: "RECEITA BRUTA"
    };
    @Input() config: {
        hideReference?: boolean;
    } = {
        hideReference: false
    };

    @Output() formChange = new EventEmitter<FormDreBalanceOptions>();

    public options = input.required<VisualizationOptionsType>();

    public onFormChange(): void {
        this.formChange.emit(this.form);
    }
}

type FormDreBalanceOptions = {
    analysisHorizontal: boolean;
    analysisVertical: boolean;
    verticalReference?: DREVerticalReferences;
};
